module.exports = __webpack_public_path__ + "static/media/vCard.b909f20d.png";